/** Site-wide notice: nothing while loading; hide when the list is empty. */
export function shouldShowAnnouncementsNotice({ loading, items }) {
  if (loading) return false;
  return Array.isArray(items) && items.length > 0;
}
